import { FilterOption, FilterOptionValueType } from '../types/odataFilterOption';
import { OdataComparator } from '../types/odataComparator';

const {
  Any,
  Contains,
  Equals,
  GreaterThan,
  GreaterThanOrEqualTo,
  In,
  LessThan,
  LessThanOrEqualTo,
  NotEquals
} = OdataComparator;
const { EnumType } = FilterOptionValueType;

export const generateODataQueryString = (
  property: string | undefined,
  comparator: OdataComparator | undefined,
  value: string[] | string | number | boolean | null,
  filterOption?: FilterOption
) => {
  switch (comparator) {
    case Contains:
      return typeof value === 'number'
        ? `contains(cast(${property}, 'Edm.String'), '${value}')`
        : `contains(tolower(${property}), '${value}')`;
    case Equals:
      return `${property} eq ${value}`;
    case In:
      return filterOption && filterOption.valueType === EnumType
        ? `(${value &&
            value
              .toString()
              .split(',')
              .map(item => property + ' eq ' + item)
              .join(' or ')})`
        : `${property} in (${value?.toString()})`;
    case GreaterThan:
      return `${property} gt ${value}`;
    case GreaterThanOrEqualTo:
      return `${property} ge ${value}`;
    case LessThan:
      return `${property} lt ${value}`;
    case LessThanOrEqualTo:
      return `${property} le ${value}`;
    case NotEquals:
      return `${property} ne ${value}`;
    case Any:
      return `${property}/any()`;
    default:
      return '';
  }
};
